import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { AddButtonLink, Browse, usePagination } from '@/core/components';

import { FilterBox, SearchFilter, useSearch, useSortDirection } from '@feature/utils';

import { EditorialTeamCard } from './components/Card/EditorialTeamCard';
import { getEditorialTeamPagedOptions } from './model/EditorialTeamQuery';

export function EditorialTeamBrowse() {
  const { t } = useTranslation();
  const { sortDirection, toggleSortDirection } = useSortDirection('DESC');
  const { search, searchProps } = useSearch();
  const { pagination, useTotalElements, ...paginationProps } = usePagination({ search });
  const { data } = useSuspenseQuery(
    getEditorialTeamPagedOptions({
      ...pagination,
      sortDirection,
      search,
    }),
  );
  useTotalElements(data);

  return (
    <Browse
      actions={<AddButtonLink />}
      title={t('editorialTeams.title')}
      pagination={paginationProps}
      filters={
        <FilterBox>
          <SearchFilter
            label={t('label.search')}
            description={t('editorialTeams.searchBy')}
            {...searchProps}
          />
        </FilterBox>
      }
      sortDirection={sortDirection}
      sortedBy={t('editorialTeams.sortedByStartYear')}
      toggleSortDirection={toggleSortDirection}
      data={data.list}
      renderItem={editorialTeam => (
        <EditorialTeamCard
          key={editorialTeam.id}
          editorialTeam={editorialTeam}
          to={`${editorialTeam.id}`}
        />
      )}
    />
  );
}
